/**
 * Internal dependencies
 */
import background from './background';
import gradient from './gradient';
import text from './text';

export default [ text, gradient, background ];
